import { useCallback, useEffect, useRef } from 'react';

/**
 * @template {Function} C
 * @param {C} callback
 * @param {number} ms
 * @returns {C}
 */
export default function useDebouncedCallback(callback, ms) {
    const callbackRef = useRef(callback);
    useEffect(() => {
        callbackRef.current = callback;
    });

    const activeTimeout = useRef();
    useEffect(() => {
        return () => clearTimeout(activeTimeout.current);
    }, []);

    return useCallback(
        (...args) => {
            clearTimeout(activeTimeout.current);
            activeTimeout.current = setTimeout(() => {
                const innerCallback = callbackRef.current;
                innerCallback(...args);
            }, ms);
        },
        [ms]
    );
}
